(() => {
  if (window.technastWorkshopMounted) return;
  window.technastWorkshopMounted = true;
  const mounts = new Map();
  const mount = root => {
    if (mounts.has(root)) return;
    const controller = new AbortController(), {signal} = controller;
    const buttons = [...root.querySelectorAll('[data-station]')];
    const objects = [...root.querySelectorAll('[data-object]')];
    const details = [...root.querySelectorAll('[data-detail]')];
    const motion = root.querySelector('[data-motion]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let selected = 0, frame = 0, elapsed = 0, previous = 0, visible = true;
    let paused = reduced.matches || !!navigator.connection?.saveData;
    const duration = 9000;
    const select = index => {
      selected = index; elapsed = 0;
      const key = buttons[index].dataset.station;
      root.dataset.active = key;
      buttons.forEach((b,i) => {b.setAttribute('aria-pressed',String(i === index)); b.style.setProperty('--progress','0');});
      objects.forEach(el => el.classList.toggle('is-active',el.dataset.object === key));
      details.forEach(el => {
        const active = el.dataset.detail === key;
        el.hidden = !active;
        el.setAttribute('aria-hidden',String(!active));
      });
    };
    const tick = time => {
      if (previous) elapsed += Math.min(time - previous,100);
      previous = time;
      if (elapsed >= duration) select((selected + 1) % buttons.length);
      buttons[selected].style.setProperty('--progress',String(elapsed / duration));
      frame = requestAnimationFrame(tick);
    };
    const sync = () => {
      cancelAnimationFrame(frame); previous = 0;
      const running = !paused && !reduced.matches && visible && !document.hidden;
      root.classList.toggle('tw-running',running);
      root.classList.toggle('tw-paused',paused || reduced.matches);
      root.classList.toggle('tw-suspended',!visible || document.hidden);
      motion.textContent = paused || reduced.matches ? motion.dataset.play : motion.dataset.pause;
      motion.setAttribute('aria-pressed',String(paused || reduced.matches));
      if (running) frame = requestAnimationFrame(tick);
    };
    buttons.forEach((button,index) => button.addEventListener('click',() => select(index),{signal}));
    motion.hidden = reduced.matches;
    motion.addEventListener('click',() => {paused = !paused; sync();},{signal});
    root.addEventListener('focusin',event => {
      if (event.target !== motion && event.target.matches(':focus-visible')) {paused = true; sync();}
    },{signal});
    reduced.addEventListener('change',() => {paused = reduced.matches; motion.hidden = reduced.matches; sync();},{signal});
    document.addEventListener('visibilitychange',sync,{signal});
    const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting; sync();},{threshold:.1});
    observer.observe(root);
    root.classList.add('tw-enhanced'); select(0); sync();
    mounts.set(root,() => {cancelAnimationFrame(frame); observer.disconnect(); controller.abort(); mounts.delete(root);});
  };
  const initialize = scope => scope.querySelectorAll('[data-workshop]').forEach(mount);
  initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
  document.addEventListener('shopify:section:unload',event => mounts.forEach((cleanup,root) => {if(event.target.contains(root)) cleanup();}));
})();
